import request from "./request";

/**
 * RemoteLock host API client. All routes are host-authenticated on the
 * backend (authMiddleware + ownership of :hid). The backend returns 503 with
 * code REMOTELOCK_DISABLED while the integration flag is off.
 */

const base = (hid) => `/integrations/remotelock/hosts/${hid}`;

export const REMOTELOCK_DISABLED_CODE = "REMOTELOCK_DISABLED";

export const isRemoteLockDisabledError = (error) =>
  error?.response?.status === 503 && error?.response?.data?.code === REMOTELOCK_DISABLED_CODE;

export const getRemoteLockErrorMessage = (error, fallback = "RemoteLock request failed") =>
  error?.response?.data?.message || error?.response?.data?.error || error?.message || fallback;

export const getRemoteLockOauthUrl = (hid) => request.get(`${base(hid)}/oauth-url`).then((r) => r.data);
export const completeRemoteLockOauth = (hid, { code, state }) => request.post(`${base(hid)}/oauth-callback`, { code, state }).then((r) => r.data);
export const getRemoteLockStatus = (hid) => request.get(`${base(hid)}/status`).then((r) => r.data);
export const disconnectRemoteLock = (hid) => request.post(`${base(hid)}/disconnect`).then((r) => r.data);
export const getRemoteLockInventory = (hid) => request.get(`${base(hid)}/inventory`).then((r) => r.data);
export const refreshRemoteLockInventory = (hid) => request.post(`${base(hid)}/inventory/refresh`).then((r) => r.data);
export const getRemoteLockMappings = (hid) => request.get(`${base(hid)}/mappings`).then((r) => r.data);
export const saveRemoteLockMapping = (hid, pid, body) => request.put(`${base(hid)}/properties/${pid}/mapping`, body).then((r) => r.data);
export const removeRemoteLockMapping = (hid, pid) => request.delete(`${base(hid)}/properties/${pid}/mapping`).then((r) => r.data);
export const getRemoteLockAccesses = (hid, limit = 50) => request.get(`${base(hid)}/accesses`, { params: { limit } }).then((r) => r.data);

/**
 * Devices a host may pick as a property's entry point. Door groups are
 * allowed; non-entry devices (thermostats, sensors) and unknown types are not.
 */
export const selectableInventoryDevices = (devices = []) =>
  devices.filter((d) => ["entry_device", "door_group"].includes(d.accessClass) && d.seenInLastSync !== false);

export const describeDeviceCapabilities = (device) => {
  if (!device) return "";
  if (device.type === "door_group") return `Door group · ${device.groupMembers?.length || 0} doors`;
  const parts = [];
  if (device.supportsRemoteUnlock === true) parts.push("Remote unlock");
  else if (device.supportsRemoteUnlock === false) parts.push("PIN only");
  else parts.push("Capabilities unknown");
  if (device.connected === false) parts.push("offline");
  return parts.join(" · ");
};

export const ACCESS_STATUS_LABELS = {
  scheduled: "Scheduled",
  provisioning: "Preparing",
  provisioned: "Syncing to lock",
  ready: "Ready",
  active: "In use",
  expired: "Expired",
  revoking: "Revoking",
  revoked: "Revoked",
  revocation_unconfirmed: "Revocation pending",
  failed: "Failed",
  cancelled: "Cancelled",
  superseded: "Replaced",
};
